export default "__VITE_ASSET__DypH3fyr__"